import {DatabaseCode, toDatabaseCode} from "./database-code";
import {TransportCategory} from "./transport-category";


export interface SupplementalType extends DatabaseCode {
}

const ticket: SupplementalType = {
  code: 'TICKET',
  displayValue: {
    id: 'common.entity.supplementaltype.ticket',
    defaultMessage: 'Ticket',
  },
};

const containerLevel: SupplementalType = {
  code: 'TANK_LEVEL',
  displayValue: {
    id: 'common.entity.supplementaltype.tanklevel',
    defaultMessage: 'Container Level',
  },
};

const regulatoryForm: SupplementalType = {
  code: 'REGULATORY_FORM',
  displayValue: {
    id: 'common.entity.supplementaltype.regulatoryform',
    defaultMessage: 'Regulatory Form',
  },
};

const logo: SupplementalType = {
  code: 'COMPANY_LOGO',
  displayValue: {
    id: 'common.entity.entity.supplementaltype.companylogo',
    defaultMessage: 'Logo',
  },
};

const other: SupplementalType = {
  code: 'OTHER',
  displayValue: {
    id: 'common.entity.supplementaltype.other',
    defaultMessage: 'Other',
  },
};

export const supplementalType = {
  ticket,
  containerLevel,
  regulatoryForm,
  logo,
  other,
};

export const supplementalTypes = Object.values(supplementalType);

export const toSupplementalType = (code: string): TransportCategory => toDatabaseCode(code, supplementalTypes);
